/**
 * FETC BTS Article Redesign — JavaScript
 * Deploy to: assets/fetc-redesign-bts.js (new file, upgrade-safe)
 * Loaded by: templates/article.fetc-bts.json via <script defer>
 * Scope: body.template-suffix-fetc-bts only
 *
 * Features:
 *   1. Epigraph extraction — converts opening ancient-proverb / quote paragraph
 *      into <blockquote class="fetc-epigraph"> so CSS can apply drop-cap to
 *      the following narrative lead paragraph via .rte > p:first-of-type.
 *
 * No dependencies. Vanilla JS only.
 * Target: Chrome 90+, Safari 14+, Firefox 88+.
 */

(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     Guard: only run on fetc-bts template
     ────────────────────────────────────────────────────────── */
  if (!document.body.classList.contains('template-suffix-fetc-bts')) return;

  /* ──────────────────────────────────────────────────────────
     Epigraph extraction
     Scans the first non-empty <p> inside the BTS RTE container and
     optionally converts it into <blockquote class="fetc-epigraph">.

     Logic mirrors build_preview.py split_epigraph() exactly:

     Case A — EN/FR dash-split: "quote" — attribution
       Pattern: opening curly/straight double-quote  →  em/en/hyphen-minus dash  →  rest
       → <blockquote class="fetc-epigraph">quote</blockquote>
          <p>Attribution (sentence-cased)</p>
       Trigger: text starts with " or " AND regex matches "quote" — rest

     Case B — standalone short or fully-quoted paragraph
       - len(text) <= 130  OR
       - first char in " " « 「 『  AND  last char in " " » 」 』
       → <blockquote class="fetc-epigraph">inner HTML</blockquote>
         (CJK quoting brackets kept intact inside the blockquote)

     Case C — anything else → no-op (first <p> becomes the drop-cap lead)

     Idempotency guard: if the element immediately before the first <p>
     is already a .fetc-epigraph blockquote, the function returns early.
     ────────────────────────────────────────────────────────── */
  function initEpigraph() {
    /* BTS RTE selector: .article--main .container--reading-width .rte.cf */
    var rte = document.querySelector('.article--main .container--reading-width .rte.cf');
    if (!rte) return;

    /* Find first non-empty <p> */
    var paragraphs = rte.querySelectorAll('p');
    var firstP = null;
    for (var i = 0; i < paragraphs.length; i++) {
      if (paragraphs[i].textContent.trim() !== '') {
        firstP = paragraphs[i];
        break;
      }
    }
    if (!firstP) return;

    /* Idempotency: already processed if previous sibling is .fetc-epigraph */
    var prev = firstP.previousElementSibling;
    if (prev && prev.classList && prev.classList.contains('fetc-epigraph')) return;

    var inner = firstP.innerHTML.trim();
    /* Strip HTML tags for plain-text checks */
    var text = inner.replace(/<[^>]+>/g, '').trim();

    /* Case A — EN/FR: "quote" — attribution
       Python regex: r'^\s*([""][^"""]+[""])\s*[—–-]\s*(.+)$'
       + guard: text[:1] in '""'
       We replicate with a JS RegExp on inner (which may contain spans/em).
       For the text-start guard we use the stripped text. */
    var OPEN_DOUBLE = '""'; /* " " */
    if (OPEN_DOUBLE.indexOf(text.charAt(0)) !== -1) {
      /* Match on inner HTML: opening quote char, content, closing quote char,
         optional whitespace, em/en/hyphen dash, rest */
      var dashRe = /^\s*([""][^"""]+[""])\s*[—–\-]\s*(.+)$/s;
      var mq = dashRe.exec(inner);
      if (mq) {
        var epiContent = mq[1].trim();
        var rest = mq[2].trim();
        /* Sentence-case the attribution (capitalise first char) */
        if (rest.length > 0) {
          rest = rest.charAt(0).toUpperCase() + rest.slice(1);
        }
        var bq = document.createElement('blockquote');
        bq.className = 'fetc-epigraph';
        bq.innerHTML = epiContent;
        var newP = document.createElement('p');
        newP.innerHTML = rest;
        firstP.parentNode.insertBefore(bq, firstP);
        firstP.parentNode.insertBefore(newP, firstP);
        firstP.parentNode.removeChild(firstP);
        return;
      }
    }

    /* Case B — standalone short or fully-quoted paragraph
       Python: text[:1] in '""«「『' and text[-1:] in '""»」』'
       threshold: len(text) <= 130 */
    var OPEN_QUOTES  = '""«「『'; /* " " « 「 『 */
    var CLOSE_QUOTES = '""»」』'; /* " " » 」 』 */
    var isQuoted = (OPEN_QUOTES.indexOf(text.charAt(0)) !== -1) &&
                   (CLOSE_QUOTES.indexOf(text.charAt(text.length - 1)) !== -1);
    if (text.length <= 130 || isQuoted) {
      var bqB = document.createElement('blockquote');
      bqB.className = 'fetc-epigraph';
      bqB.innerHTML = inner;
      firstP.parentNode.insertBefore(bqB, firstP);
      firstP.parentNode.removeChild(firstP);
      return;
    }
    /* Case C — no-op */
  }

  /* ──────────────────────────────────────────────────────────
     Init — run after DOM is ready
     ────────────────────────────────────────────────────────── */
  function init() {
    initEpigraph();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
